import { useUpdateEffect } from 'react-use';
import styled from 'styled-components';

import { useFormController } from '@dreryk/react-common';
import { ActionInput } from '@dreryk/react-components';

import { receptionServiceTranslationKeys } from '../../translations';

export const StyledActionInput = styled(ActionInput)`
   width: 537px;
`;

StyledActionInput.displayName = 'StyledActionInput';

type ReceptionServiceTableSearchFormBean = {
   searchText: string | null;
};

type ReceptionServiceTableSearchProps = {
   readonly onChange: (searchText: string | null) => void;
};

export const ReceptionServiceTableSearch = (props: ReceptionServiceTableSearchProps): JSX.Element => {
   const { register, watch } = useFormController<ReceptionServiceTableSearchFormBean>({ searchText: null });
   const searchText = watch('searchText');

   useUpdateEffect(() => props.onChange(searchText), [searchText]);

   return (
      <StyledActionInput
         controller={register('searchText')}
         placeholder={receptionServiceTranslationKeys.table.search.placeholder}
         testId={'receptionService'}
         autoFocus
      />
   );
};
